import { InjectionToken } from '@angular/core';

export type Country = {
  name: string;
  code: string;
  countryCode: number;
};

import type { SelectOption } from '../select/select.component';

export type CountrySelectOption = SelectOption & { countryCode: number };

export const PHONE_INPUT_DATA = new InjectionToken<Country[]>('PHONE_INPUT_DATA');
